"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const _utils_1 = require("@utils"); // Component
var Margin = function Margin(_ref) {
    var children = _ref.children, className = _ref.className, _ref$noGutter = _ref.noGutter, noGutter = _ref$noGutter === void 0 ? false : _ref$noGutter, _ref$id = _ref.id, id = _ref$id === void 0 ? undefined : _ref$id;
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, Object.assign({
        className: className
    }, {
        noGutter: noGutter,
        id: id
    }), children);
}; // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "Margin__Wrapper",
    componentId: "z8b16o-0"
})(["padding:0 24px;margin:0 auto;", "{max-width:768px;padding:", ";}", "{max-width:1024px;}", "{max-width:1280px;}"], _utils_1.mediaQuery('tablet'), function (props) {
    return props.noGutter ? '0' : '0 40px';
}, _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop')); // Typing
exports.default = Margin;
